export default {
    appVersion: state => state.packageVersion,
    softwareVersion: state => state.softwareVersion,
}